import {
  CHANGE_ACTIVE_ITEM_HOME, CHANGE_ACTIVE_ITEM_RESUME,
  CHANGE_ACTIVE_ITEM_LIVELIST, CHANGE_ACTIVE_ITEM_LIVELIST_MATRIX,
  CHANGE_ACTIVE_ITEM_TAG, CHANGE_ACTIVE_ITEM_GRAPHIC_TOPOLOGY, 
  CHANGE_ACTIVE_ITEM_LOG, CHANGE_ACTIVE_ITEM_CONFIG, SOLVE_PROBLEM,
  CHANGE_ACTIVE_ITEM_OPTIC_FIBER, CHANGE_ACTIVE_ITEM_OPTIC_FIBER_LOG
} from "../actions/types";

// ---- Actions ----
export function homeAction() {
  return {
    type: CHANGE_ACTIVE_ITEM_HOME,
    payload: { activeItem: "/" }
  };
}

export function resumeAction() {
  return {
    type: CHANGE_ACTIVE_ITEM_RESUME,
    payload: { activeItem: "/resume" }
  };
}

export function livelistAction() {
  return {
    type: CHANGE_ACTIVE_ITEM_LIVELIST,
    payload: { activeItem: "/livelist" }
  };
}

export function liveListMatrixAction() {
  return {
    type: CHANGE_ACTIVE_ITEM_LIVELIST_MATRIX,
    payload: { activeItem: "/livelist-matrix" }
  };
}

export function graphicTopologyAction() {
  return {
    type: CHANGE_ACTIVE_ITEM_GRAPHIC_TOPOLOGY,
    payload: { activeItem: "/graphic-topology" }
  };
}

export function opticFiberAction() {
  return {
    type: CHANGE_ACTIVE_ITEM_OPTIC_FIBER,
    payload: { activeItem: "/optic-fiber" }
  };
}

export function OpticFiberLogAction() {
  return {
    type: CHANGE_ACTIVE_ITEM_OPTIC_FIBER_LOG,
    payload: { activeItem: "/optic-fiber-log" }
  };
}

export function tagAction() {
  return {
    type: CHANGE_ACTIVE_ITEM_TAG,
    payload: { activeItem: "/tags" }
  };
}

export function logAction() {
  return {
    type: CHANGE_ACTIVE_ITEM_LOG,
    payload: { activeItem: "/log" }
  };
}

export function configAction() {
  return {
    type: CHANGE_ACTIVE_ITEM_CONFIG,
    payload: { activeItem: "/config" }
  };
}

export function solveProblemAction(solve, problem) {
  return {
    type: SOLVE_PROBLEM,
    payload: { 
      solve: solve,
      problem: problem 
    }
  };
}